import SegmentPage from "./SegmentPage";

const config = {
  eyebrow: "Privatkunden",
  seoTitle: "Energieberatung für Privatkunden",
  titleLines: ["Für Ihr Zuhause –", 'ehrlich & <span class="font-serif italic text-blue-700">persönlich.</span>'],
  subtitle: "Unabhängige Beratung für Haushalte: Wir prüfen Strom und Gas, finden den besten Tarif und übernehmen den Wechsel für Sie.",
  path: "/privatkunden",
  image: "family",
  sideImage: "family",
  topic: "privatkunden",
  intro: "Als Privathaushalt profitieren Sie von echter, unabhängiger Beratung statt undurchsichtiger Vergleichsportale – schnell, ehrlich und sicher.",
  points: [
    { title: "Persönliche Betreuung", text: "Sie sprechen direkt mit Ihrer Beraterin – kein Callcenter, keine Warteschleife." },
    { title: "Kostenlose Rechnungsanalyse", text: "Foto oder PDF hochladen genügt. Wir zeigen Ihnen ehrlich Ihr Sparpotenzial." },
    { title: "Wechselservice inklusive", text: "Kündigung und Anbieterwechsel erledigen wir komplett für Sie." },
    { title: "Angebot in 24 Stunden", text: "Werktags erhalten Sie Ihr individuelles Angebot innerhalb eines Tages." },
    { title: "DSGVO-konform", text: "Ihre Daten werden vertraulich behandelt und nicht an unbefugte Dritte weitergegeben." },
  ],
};

export default function Privatkunden() {
  return <SegmentPage config={config} />;
}
